<template>
    <div class="add-edit-supplier">
        <v-form @submit.prevent="submitSupplierDetails" v-model="supplierDetailsForm" ref="supplierDetailsForm">
            <v-row>
                <v-col cols="8">
                    <h1 class="text-left ml-8 my-2">
                        <span v-if="!is_editing">Add</span>
                        <span v-else>Edit</span> Supplier
                    </h1>
                    <p v-if="!is_editing" class="text-left ml-8">Add a new Supplier</p>
                    <p v-else class="text-left ml-8">Edit exisiting Supplier.</p>
<h4
              class="text-left ml-8 my-2 red--text"
              v-if="supplier.has_purchase_orders"
            >Cannot be edited or deleted since Supplier has existing purchase orders.</h4>
                    <h5 class="text-left ml-8 font-weight-regular">* indicates required field</h5>


                </v-col>
                <v-col cols="4" class="text-right">
                    <v-btn
                        v-if="is_editing && currentUser.privileges.canDeleteSuppliers"
                        color="red"
                        class="my-2 mr-8"
                        dense
                        small
                        :disabled="supplier.has_purchase_orders"
                        @click="showDeleteDialog"
                        rounded
                        outlined
                    >Delete</v-btn>
                </v-col>
            </v-row>

            <v-row class="mx-4">
                <v-col cols="12">
                    <v-card>
                        <v-container>
                            <v-row>
                                <v-col cols="12" md="4">
                                    <p class="text-left mx-2 mb-1">Supplier Name
                                        <span class="required"></span>
                                    </p>
                                    <v-text-field
                                        v-model="supplier.supplier_name"
                                        outlined
                                        :rules="[rules.required, rules.supplier_name]"
                                        dense
                                        placeholder="eg. ABC Supplier"
                                        class="rounded-input"
                                        hide-details="auto"
                                        maxlength="55"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <p class="text-left mx-2 mb-1">
                                    Supplier Type
                                    <span class="required"></span>
                                    </p>
                                    <v-autocomplete
                                        v-model="supplier.supplier_type"
                                        :items="supplier_types"
                                        :rules="[rules.required]"
                                        item-text="type_name"
                                        item-value="id"
                                        class="rounded-input"
                                        outlined
                                        dense
                                        hide-details="auto"
                                        return-object
                                    >
                                    </v-autocomplete>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <p class="text-left mx-2 mb-1">Region
                                        <span class="required"></span>
                                    </p>
                                    <v-text-field
                                        v-model="supplier.region"
                                        outlined
                                        :rules="[rules.required]"
                                        dense
                                        placeholder="eg. Mumbai"
                                        class="rounded-input"
                                        hide-details="auto"
                                        maxlength="55"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <p class="text-left mx-2 mb-1">Phone
                                        <span class="required"></span>

                                    </p>
                                    <v-text-field
                                        v-model="supplier.phone_one"
                                        outlined
                                        :rules="[rules.required, rules.phone, rules.phoneNumberLength]"
                                        dense
                                        placeholder="eg. 9876543210"
                                        class="rounded-input"
                                        maxlength="10"
                                        counter="10"
                                        hide-details="auto"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <p class="text-left mx-2 mb-1">Alternate Phone</p>
                                    <v-text-field
                                        v-model="supplier.phone_two"
                                        outlined
                                        :rules="[rules.phone]"
                                        dense
                                        placeholder="eg. 9876543210"
                                        class="rounded-input"
                                        maxlength="10"
                                        counter="10"
                                        hide-details="auto"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <p class="text-left mx-2 mb-1">Helpdesk</p>
                                    <v-text-field
                                        v-model="supplier.help_desk"
                                        outlined
                                        dense
                                        placeholder="eg. 1800-XXX-XXX"
                                        class="rounded-input"
                                        hide-details="auto"
                                    ></v-text-field>
                                </v-col>
                                
                                <v-col cols="12" md="8">
                                    <p class="text-left mx-2 mb-1">Address</p>
                                    <v-textarea
                                        name="input-7-1"
                                        placeholder="eg. Akshya Nagar 1st Block 1st Cross, Rammurthy nagar, Bangalore-560016"
                                        outlined
                                        v-model="supplier.address"
                                        class="rounded-input"
                                        dense
                                        rows="3"
                                        hide-details="auto"
                                    ></v-textarea>
                                </v-col>
                            </v-row>
                            <div class="text-right mx-4 my-4">
                                <v-btn
                                    class="mr-4"
                                    color="red"
                                    :to="{ name:'SupplierDetails', params: { id: this.$route.params.supplier_id } }"
                                    v-if="!is_editing"
                                    rounded
                                    outlined
                                >Cancel</v-btn>
                                <v-btn
                                    class="mr-4"
                                    color="red"
                                    :to="{name:'Suppliers' }"
                                    v-else
                                    rounded
                                    outlined
                                >Cancel</v-btn>
                                <v-btn color="primary" type="submit" :disabled="!supplierDetailsForm" rounded>Submit</v-btn>
                            </div>
                        </v-container>
                    </v-card>
                </v-col>
            </v-row>
        </v-form>
        <DeleteConfirmationDialog
            title="Are you sure you want to delete this Supplier?"
            :visible="showDeleteConfirmation"
            @deleteObject="deleteObjectConfirmation"
        />
        <v-snackbar v-model="snackbar.visible" timeout="5000" :color="snackbar.color" multi-line>
            {{ snackbar.text }}
            <template v-slot:action="{ attrs }">
                <v-btn dark text v-bind="attrs" @click="snackbar.visible = false">Close</v-btn>
            </template>
        </v-snackbar>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import endpoints from "@api/repository";
import api from "@api/index";
import DeleteConfirmationDialog from "@components/widgets/dialogs/DeleteConfirmationDialog";

export default {
    name: 'AddEditSupplier',
    components:{
        DeleteConfirmationDialog,
    },
    data(){
        return{
            supplierDetailsForm: true,
            is_editing: false,
            rules: {
                required: (v) => !!v || "This field is required",
                supplier_name: (v) => /^[a-zA-Z0-9_ ]{1,55}$/.test(v) || "Invalid",
                phone: (v) => !v || !/[^0-9]/.test(v) || "Invalid",
                phoneNumberLength: (v) => !v || v?.length == 10 || "Should be 10 Digits",

            },
            snackbar: {
                visible: false,
                text: "",
            },
            supplier_types: [],
            supplier: {
                supplier_name: null,
                phone_one: null,
                phone_two: null,
                address: null,
                region: null,
                help_desk: null,
                supplier_type: null,
            },
            showDeleteConfirmation: false,
        }
    },
    computed:{
        ...mapGetters(["currentUser", "accessToken", "isLoading"]),
        essentials() {
            return {
                accessToken: this.accessToken,
                setLoading: this.setLoading,
                handleErrorsFunction: this.handleApiErrors,
            };
        },
    },
    methods: {
        ...mapActions(["setLoading"]),
        async getSupplierDetails(){
            var url = endpoints.suppliers + this.$route.params.id + "/";
            this.supplier = await api.call(this.essentials, url);
        },

        async getAllSupplierTypes(){
            this.supplier_types = await api.call(this.essentials, endpoints.supplierType);
        },

        async submitSupplierDetails(){
            var response;
            response = await api.handleApi({
                apiEssentials: this.essentials,
                url: endpoints.suppliers,
                responseVar: response,
                method: api.Methods.POST,
                body: {
                    is_editing: this.is_editing,
                    edit_id: this.is_editing? this.supplier.id : null,
                    supplier_name: this.supplier.supplier_name,
                    phone_one: this.supplier.phone_one,
                    phone_two: this.supplier.phone_two,
                    address: this.supplier.address,
                    region: this.supplier.region,
                    help_desk: this.supplier.help_desk,
                    supplier_type_id: this.supplier.supplier_type.id,
                },
            });
            if(response){
                this.$router.push({ name: 'Suppliers' });
            }
        },
        async showDeleteDialog(){
            this.showDeleteConfirmation = true;
        },

        async deleteObjectConfirmation(confirm) {
            this.showDeleteConfirmation = false;
            var url = endpoints.suppliers + this.supplier.id + "/"; 
            if (confirm) {
                var response;
                response = await api.handleApi({
                    apiEssentials: this.essentials,
                    url: url,
                    method: api.Methods.DELETE,
                    responseVar: response,
                });
                if (response) {
                    this.$router.push({ name: "Suppliers" });
                }
            }
        },

        // handles api errors
        handleApiErrors(err) {
            this.setLoading(false);
            if (err.response) {
                console.log(err.response);
                
            } else {
                this.snackbar.text = "Unknown error occurred";
                this.snackbar.visible = true;
            }
        },
    },
    created(){
        this.getAllSupplierTypes();
        if(this.$route.params.id){
            this.is_editing = true;
            this.getSupplierDetails();
        }
    }

}
</script>

<style scoped>
.rounded-input {
  border-radius: 12px !important;
}
</style>
